import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Mission } from '../data-management.model';
import { MissionSuiviRequest, PlanificationAssignmentAddDto } from '.';
import { dns } from 'src/app/global.config';
import { Truck } from './planification-mission/planification.model';
import { createAuthorizationHeader } from 'src/app/utils/security/headers';

@Injectable({
  providedIn: 'root'
})
export class PlanificationService {
  private apiUrl = dns;

  constructor(private http: HttpClient) { }

  // Get all available missions
  getMissions(): Observable<Mission[]> {
    return this.http.get<Mission[]>(`${this.apiUrl}/missions`);
  }

  // Get all trucks
  getAllTrucks(): Observable<Truck[]> {
    return this.http.get<Truck[]>(this.apiUrl);
  }

  // Get a truck by ID
  getTruckById(id: number): Observable<Truck> {
    return this.http.get<Truck>(`${this.apiUrl}/${id}`);
  }

  // Create a new truck planning
  createTruckMission(truck: Truck): Observable<Truck[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<Truck[]>(`${this.apiUrl}planificationApi`, truck, options);
  }


  getAllVehiclePlanifications(): Observable<Truck[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.get<Truck[]>(`${this.apiUrl}planificationApi`, options);
  }




  // Update an existing truck planning
  updateTruck(id: number, dto: PlanificationAssignmentAddDto): Observable<Truck> {
    return this.http.put<Truck>(`${this.apiUrl}/${id}`, dto);
  }

  // Delete a truck planning
  deleteTruck(id: number): Observable<void> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.delete<void>(`${this.apiUrl}planificationApi/${id}`,options);
  }

  // Get trucks with missions for today
  getTodayMissions(): Observable<Truck[]> {
    return this.http.get<Truck[]>(`${this.apiUrl}/today`);
  }

  getSuiviMissionExcel(request:MissionSuiviRequest) : Observable<Blob>{
    let headers = createAuthorizationHeader();    
    return this.http.post<Blob>(`${this.apiUrl}planificationApi/suivi/excel`,request,{ headers: headers, responseType: 'blob' as 'json' });
  }
}

